export const PERMISSION_SET_FIELDS = [
  { field: 'name', label: 'Name', renderAs: 'TextField', colSize: 24 },
  {
    field: 'organisation_groups',
    label: 'Organisation Groups',
    renderAs: 'MultiDropDown',
    colSize: 24,
  },
];
